import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'
import events from './Events'
import pages from './Pages'
import albums from './Albums'
import session from './Session'
import podcasts from './Podcasts'
import streamings from './Streamings'
const reducers = combineReducers({events, pages, albums, session, podcasts, streamings, form: formReducer})

export default reducers;



// WEBPACK FOOTER //
// ./src/reducers/index.js